module.exports = __webpack_public_path__ + "img/s00131.1d8e30aa.png";